export enum OfferTypeEnum {
  FIXED = 'FIXED',
  DYNAMIC = 'DYNAMIC'
}
